/**
 * Created by stonewang on 2017/8/29.
 */
import {config, request} from 'Utils';

/*获取订单列表数据*/
export function getOrderList(param) {
    return request(`${config.server}/api/v1/dms/trans/order/list`, {
        method: 'post',
        body: {...param}
    });
}

/*获取销售排行列表数据*/
export function getRankList(param) {
    return request(`${config.server}/api/v1/dms/trans/order/rankList`, {
        method: 'post',
        body: {...param},
    });
}

/*销售明细报表*/
export function getSalesList(param) {
    return request(`${config.server}/api/v1/dms/trans/order/saleslist`, {
        method: 'post',
        body: {...param}
    });
}

/*删除*/
export function deleteList(param) {
    return request(`${config.server}/api/v1/dms/trans/order/deleteOrder`, {
        method: 'post',
        body: param
    });
}

/*获取订单详情数据*/
export function detail(id) {
    return request(`${config.server}/api/v1/dms/trans/order/detail?id=${id}`, {
        method: 'get'
    });
}

/*点击搜索订单商品 二级产品列表*/
export function getPro(param) {
    return request(`${config.server}/api/v1/dms/trans/otherPro/DmsAndOtherProList`, {
        method: 'post',
        body: param
    });
}

export function getProByItems(param) {
    return request(`${config.server}/api/v1/dms/trans/otherPro/DmsAndOtherProListByItems`, {
        method: 'post',
        body: param
    });
}

/*获取历史价格*/
export function getHistoryPrice(param) {
    return request(`${config.server}/api/v1/dms/trans/otherPro/ProductHistoryPrice`, {
        method: 'post',
        body: param
    });
}

/*点击保存提交按钮*/
export function create(param) {
    return request(`${config.server}/api/v1/dms/trans/order/createOrder`, {
        method: 'post',
        body: {...param}
    });
}

/*获取下浮*/
export function getXiaFu(param) {
    return request(`${config.server}/api/v1/dms/trans/rate/getOrderRateByParam`, {
        method: 'post',
        body: {...param}
    });
}


// 已有物料
export function getProTypes(param) {
    return request(`${config.server}/api/v1/dms/tgCustomOrder/selectProType`, {
        method: 'post',
        body: {...param}
    });
}

/*二级客户列表*/
export function list2(param) {
    return request(`${config.server}/api/v1/dms/employee/secondList`, {
        method: 'post',
        body: param,
    });
}

export function listSecondList(param) {
    return request(`${config.server}/api/v1/dms/employee/orderSecondList`, {
        method: 'post',
        body: param,
    });
}

/*获取子库列表*/
export function getSubStoreList(param) {
    return request(`${config.server}/api/v1/dms/dmsTianSubStore/listByPage`, {
        method: 'post',
        body: {...param},
    });
}

/* 详情登记 */
export function getRegister(id) {
    return request(`${config.server}/api/v1/dms/trans/order/register?id=${id}`, {
        method: 'get'
    });
}

/* 冲销行 */
export function getCancelLine(id) {
    return request(`${config.server}/api/v1/dms/trans/order/cancelLine?id=${id}`, {
        method: 'get'
    });
}

/* 发运、退货行 */
export function getShipLine(orderId, lineId) {
    return request(`${config.server}/api/v1/dms/trans/order/ship?orderId=${orderId}&lineId=${lineId}`, {
        method: 'get'
    });
}

/* 整单发货 */
export function getShipAll(orderId) {
    return request(`${config.server}/api/v1/dms/trans/order/ship?orderId=${orderId}`, {
        method: 'get'
    });
}

/* 删除行 */
export function getDelLine(orderId, lineId) {
    return request(`${config.server}/api/v1/dms/trans/order/delLine?orderId=${orderId}&lineId=${lineId}`, {
        method: 'get'
    });
}

/*驳回二级客户提交的订单*/
export function rejectOrder(param) {
    return request(`${config.server}/api/v1/dms/trans/order/reject`, {
        method: 'post',
        body: {...param},
    });
}

/* 二级客户提交订单 */
export function submitOrder(id) {
    return request(`${config.server}/api/v1/dms/trans/order/submit?id=${id}`, {
        method: 'get'
    });
}



// WEBPACK FOOTER //
// ./src/service/thingsOrder/index.js